module.exports = __webpack_public_path__ + "img/icon_map_xiaofangshuan_gaojing.6a48ab52.svg";